var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0627 16.875V17.5781C14.0627 18.324 13.7664 19.0394 13.239 19.5669C12.7115 20.0943 11.9962 20.3906 11.2502 20.3906C10.5043 20.3906 9.78896 20.0943 9.26151 19.5669C8.73406 19.0394 8.43775 18.324 8.43775 17.5781V16.875M18.7948 15.4437C17.6663 14.0625 16.8695 13.3594 16.8695 9.55151C16.8695 6.06445 15.0889 4.82212 13.6233 4.21875C13.4286 4.13877 13.2454 3.95508 13.186 3.75513C12.929 2.88018 12.2083 2.10938 11.2502 2.10938C10.2922 2.10938 9.5711 2.88062 9.31665 3.75601C9.25733 3.95815 9.07408 4.13877 8.8794 4.21875C7.41206 4.823 5.63316 6.06094 5.63316 9.55151C5.63096 13.3594 4.83423 14.0625 3.70572 15.4437C3.23814 16.0159 3.64771 16.875 4.46553 16.875H18.0394C18.8528 16.875 19.2597 16.0132 18.7948 15.4437Z",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.29442079d435219fd89989505eae59c7.svg";
export { ForwardRef as ReactComponent };